import { CarouselModel, InsightItemModel, InsightsModel, ReadMoreModel } from '@_types/organisms';
import { InsightView } from '@helpers/consts';

const sectionHeading: InsightsModel['sectionHeading'] = {
  heading: 'Related publications and reports',
  subHeading: 'Optional sub heading',
  textLink: {
    text: 'Long long long long text',
    url: 'https://www.google.com',
    target: '_blank',
  },
  buttonLink: {
    text: 'Long long long long Long text',
    url: 'https://www.google.com',
  },
};

const insightItems: InsightItemModel[] = [
  {
    title: {
      text: 'The Wealth Report 2024',
      url: '#',
    },
    category: 'Report',
    description:
      'Extract from feed 140 characters description truncate after that lorem psum dolor sit amet, consectetur adipiscing elit. Extract from feed 140 characters description truncate after that lorem psum dolor sit amet, consectetur adipiscing elit. Extract from feed 140 characters description truncate after that lorem psum dolor sit amet, consectetur adipiscing elit',
    thumbnail: {
      src: '/samples/insight-demo-1.png',
      alt: 'The Wealth Report 2024',
    },
    publishedDate: '01 Dec 2024',
  },
  {
    title: {
      text: 'Country Houses, Farms & Estates, Edition 2, 2024',
      url: '#',
    },
    category: 'Publication',
    description:
      'Extract from feed 140 characters description truncate after that lorem psum dolor sit amet, consectetur adipiscing elit. Extract from feed 140 characters description truncate after that lorem psum dolor sit amet, consectetur adipiscing elit',
    thumbnail: {
      src: '/samples/insight-demo-2.png',
      alt: 'Country Houses, Farms & Estates, Edition 2, 2024',
    },
    publishedDate: '01 Dec 2024',
  },
  {
    title: {
      text: 'Prime London Sales Index - July 2023 #2',
      url: '#',
    },
    category: 'Report',
    description:
      'Extract from feed 140 characters description truncate after that lorem psum dolor sit amet, consectetur adipiscing elit. Extract from feed 140 characters description truncate after that lorem psum dolor sit amet, consectetur adipiscing elit',
    linkWithIcon: {
      icon: { iconPath: '#kf-arrow-right', viewBoxHeight: 24, viewBoxWidth: 24 },
      url: 'https://google.com',
      text: 'Read more',
    },
    publishedDate: '01 Dec 2024',
    styleModifier: ['background-highlighted'],
  },
  {
    title: {
      text: 'The Wealth Report 2024',
      url: '#',
    },
    category: 'Publication',
    description: 'Extract from feed 140 characters description truncate after that lorem psum dolor sit amet, consectetur adipiscing elit.',
    thumbnail: {
      src: '/samples/insight-demo-4.png',
      alt: 'The Wealth Report 2024',
    },
    linkWithIcon: {
      icon: { iconPath: '#kf-download', viewBoxHeight: 24, viewBoxWidth: 24 },
      url: 'https://google.com',
      text: 'Download PDF, 5MB',
    },
    publishedDate: '01 Dec 2024',
  },
];

const extendedShowMore: ReadMoreModel = {
  styleModifier: ['center'],
  expandedText: 'See more',
  maximumSeeMoreFullyLoadedQuantity: 24,
  itemPerBatch: {
    desktop: 12,
    mobile: 3,
    tablet: 6,
  },
  itemClassIdentify: 'kf-o-insights-item',
  showFirstBatchOnLoad: true,
};

const extendedNoneAllShowMore: ReadMoreModel = {
  styleModifier: ['center'],
  expandedText: 'See more',
  maximumSeeMoreFullyLoadedQuantity: 24,
  itemPerBatch: {
    desktop: 12,
    mobile: 3,
    tablet: 6,
  },
  expandedAllOnDesktop: true,
  itemClassIdentify: 'kf-o-insights-item',
  showFirstBatchOnLoad: true,
};

const insightCarousel: CarouselModel = {
  hasPagination: true,
  hasNavigation: true,
  hasPaginationClickable: false,
  hasLooping: false,
  itemType: 'insight',
  disableAutoHeight: true,
};

const insights4Items: InsightsModel = {
  carousel: {
    ...insightCarousel,
    items: [
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
    ],
  },
  sectionHeading: {
    heading: 'Related publications and reports',
    subHeading: 'Optional sub heading',
  },
};

const insights4ItemsWithSectionHeadingButton: InsightsModel = {
  carousel: {
    ...insightCarousel,
    items: [
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
    ],
  },
  sectionHeading: {
    heading: 'Related publications and reports',
    subHeading: 'Optional sub heading',
    buttonLink: {
      text: 'Long long long long long long text',
      //text: 'Label',
      url: '#',
      target: '_blank',
    },
    textLink: {
      text: 'Long long long long long long text',
      //text: 'Label',
      url: '#',
      target: '_blank',
    },
  },
};

const insights3Items: InsightsModel = {
  carousel: {
    ...insightCarousel,
    items: [
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
    ],
  },
  sectionHeading: {
    heading: 'Related publications and reports',
    subHeading: 'Optional sub heading',
  },
};

const featuredInsights: InsightsModel = {
  ...insights4Items,
};

const featuredInsightsNoHeading: InsightsModel = {
  ...insights4Items,
  sectionHeading: undefined,
  view: 'featured-grid',
  extendsView: 'none-all',
  carouselDesktop: false,
  readMore: {
    ...extendedNoneAllShowMore,
    itemPerBatch: {
      ...extendedNoneAllShowMore.itemPerBatch,
      mobileFirstBatch: 1,
      tabletFirstBatch: 4,
    },
    signpostingButton: {
      styleModifier: ['small'],
      text: 'Search posts',
      link: true,
      href: '#',
    },
  },
};

const insight2ColumnsSearchBase: InsightsModel = {
  excludeJs: true,
  excludeCss: true,
  carousel: {
    ...insightCarousel,
    excludeJs: true,
    items: [],
  },
  view: 'grid',
  carouselDesktop: false,
  gridModifier: ['2-columns'],
};

const insight2ColumnsSearchLoadMoreBase: InsightsModel = {
  ...insight2ColumnsSearchBase,
  dataSet: {
    'data-lazy-load-more-source-id': 'research-search-load-more',
  },
};

const featuredViewFullImage: InsightsModel = {
  carousel: {
    ...insightCarousel,
    items: [
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
    ],
  },
  view: 'featured',
  carouselDesktop: false,
  sectionHeading: {
    heading: 'Related publications and reports',
    subHeading: 'Optional sub heading',
    buttonLink: {
      text: 'Long long long long long long text',
      url: '#',
      target: '_blank',
    },
  },
};

const featuredViewMissingImage: InsightsModel = {
  ...featuredViewFullImage,
  carousel: {
    ...featuredViewFullImage.carousel,
    items: [
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: {
          ...insightItems[2],
          thumbnail: undefined,
          styleModifier: ['background-highlighted'],
        },
      },
      {
        insight: insightItems[3],
      },
    ],
  },
};

const featuredGridViewExtendViewNoneAll: InsightsModel = {
  carousel: {
    ...insightCarousel,
    items: [
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
    ],
  },
  view: 'featured-grid',
  extendsView: 'none-all',
  carouselDesktop: false,
  sectionHeading: {
    heading: 'Related publications and reports',
    subHeading: 'Optional sub heading',
    buttonLink: {
      text: 'Long long long long long long text',
      url: '#',
      target: '_blank',
    },
  },
  readMore: {
    ...extendedNoneAllShowMore,
    itemPerBatch: {
      ...extendedNoneAllShowMore.itemPerBatch,
      mobileFirstBatch: 1,
      tabletFirstBatch: 4,
    },
    signpostingButton: {
      styleModifier: ['small'],
      text: 'Search posts',
      link: true,
      href: '#',
    },
  },
};

const featuredGridViewExtendViewCarousel: InsightsModel = {
  ...featuredGridViewExtendViewNoneAll,
  carousel: {
    ...featuredGridViewExtendViewNoneAll.carousel,
    itemType: 'insightGroup',
  },
  carouselDesktop: true,
  readMore: undefined,
  extendsView: 'carousel',
};

const featuredGridViewExtendViewShowMore: InsightsModel = {
  ...featuredGridViewExtendViewNoneAll,
  extendsView: 'show-more',
  readMore: {
    ...extendedShowMore,
    signpostingButton: {
      styleModifier: ['small'],
      text: 'Search posts',
      link: true,
      href: '#',
    },
  },
};

const gridViewExtendViewNoneAll: InsightsModel = {
  carousel: {
    ...insightCarousel,
    items: [
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[1],
      },
    ],
  },
  view: 'grid',
  carouselDesktop: false,
  sectionHeading: {
    heading: 'Related publications and reports',
    subHeading: 'Optional sub heading',
    buttonLink: {
      text: 'Long long long long long long text',
      url: '#',
      target: '_blank',
    },
  },
  readMore: extendedNoneAllShowMore,
};

const gridViewExtendViewCarousel: InsightsModel = {
  ...gridViewExtendViewNoneAll,
  carousel: {
    ...gridViewExtendViewNoneAll.carousel,
    itemType: 'insightGroup',
  },
  carouselDesktop: true,
  readMore: undefined,
};

const gridViewExtendViewShowMore: InsightsModel = {
  ...gridViewExtendViewNoneAll,
  readMore: {
    ...extendedShowMore,
    signpostingButton: {
      styleModifier: ['small'],
      text: 'Search posts',
      link: true,
      href: '#',
    },
  },
};

const gridViewExtendViewMissingImage: InsightsModel = {
  ...gridViewExtendViewNoneAll,
  carousel: {
    ...featuredViewFullImage.carousel,
    items: [
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: {
          ...insightItems[2],
          thumbnail: undefined,
          styleModifier: ['background-highlighted'],
        },
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
    ],
  },
};

const gridViewExtendViewMissingImageNoDesc: InsightsModel = {
  ...gridViewExtendViewNoneAll,
  carousel: {
    ...featuredViewFullImage.carousel,
    items: [
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: {
          ...insightItems[2],
          thumbnail: undefined,
          styleModifier: ['background-highlighted'],
          description: undefined,
        },
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
    ],
  },
};

const gridView2ColumnsSearchPage: InsightsModel = {
  carousel: {
    ...insightCarousel,
    items: [
      {
        insight: {
          ...insightItems[0],
          styleModifier: ['horizontal', 'spacing-sm'],
        },
      },
      {
        insight: {
          ...insightItems[1],
          styleModifier: ['horizontal', 'spacing-sm'],
        },
      },
      {
        insight: {
          ...insightItems[2],
          styleModifier: ['horizontal', 'spacing-sm'],
        },
      },
      {
        insight: {
          ...insightItems[3],
          styleModifier: ['horizontal', 'spacing-sm'],
        },
      },
      {
        insight: {
          ...insightItems[0],
          styleModifier: ['horizontal', 'spacing-sm'],
        },
      },
      {
        insight: {
          ...insightItems[1],
          styleModifier: ['background-highlighted', 'spacing-sm', 'horizontal'],
          thumbnail: undefined,
        },
      },
    ],
  },
  view: 'grid',
  carouselDesktop: false,
  gridModifier: ['2-columns'],
};

const insightItemTheView = insightItems.map(({ category, title, thumbnail, publishedDate }: InsightItemModel) => ({
  category,
  title,
  thumbnail,
  publishedDate,
}));

const insightTheView: InsightsModel = {
  carousel: {
    ...insightCarousel,
    items: [
      {
        insight: {
          ...insightItemTheView[0],
          description: insightItems[0].description,
          button: {
            text: 'Read arrticle',
            href: 'https://www.google.com',
            link: true,
            styleModifier: ['secondary', 'small'],
          },
          styleModifier: ['image-square'],
        },
      },
      {
        insight: {
          ...insightItemTheView[1],
          description: insightItems[1].description,
          button: {
            text: 'Read arrticle',
            href: 'https://www.google.com',
            link: true,
            styleModifier: ['secondary', 'small'],
          },
          styleModifier: ['image-square'],
        },
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
    ],
  },
  carouselDesktop: false,
  sectionHeading: {
    heading: 'Related publications and reports',
    subHeading: 'Optional sub heading',
    buttonLink: {
      text: 'Long long long long long long text',
      url: '#',
      target: '_blank',
      styleModifier: ['secondary', 'small'],
    },
    textLink: {
      text: 'Label The View',
      url: 'https://www.google.com',
      styleModifier: ['tertiary', 'large'],
    },
  },
  theviewOptions: { featuredquantity: 2, featuredfirstviewlayout: 'left' },
  view: 'featured-the-view',
  extendsView: 'show-more',
  readMore: {
    ...extendedShowMore,
    signpostingButton: {
      styleModifier: ['primary', 'large'],
      text: 'Search posts',
      link: true,
      href: '#',
    },
  },
};

const insightTheViewCarousel: InsightsModel = {
  carousel: {
    ...insightCarousel,
    items: [
      {
        insight: {
          ...insightItemTheView[0],
          description: insightItems[0].description,
          button: {
            text: 'Read arrticle',
            href: 'https://www.google.com',
            link: true,
            styleModifier: ['secondary', 'small'],
          },
        },
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
      {
        insight: insightItemTheView[0],
      },
      {
        insight: insightItemTheView[1],
      },
      {
        insight: insightItemTheView[2],
      },
      {
        insight: insightItemTheView[3],
      },
    ],
  },
  carouselDesktop: false,
  sectionHeading: {
    heading: 'Related publications and reports',
    subHeading: 'Optional sub heading',
    buttonLink: {
      text: 'Long long long long long long text',
      url: '#',
      target: '_blank',
      styleModifier: ['secondary', 'small'],
    },
  },
  theviewOptions: { featuredquantity: 1, featuredfirstviewlayout: 'right' },
  view: 'featured-the-view',
  extendsView: 'carousel',
  readMore: {
    ...extendedShowMore,
    signpostingButton: {
      styleModifier: ['primary', 'large'],
      text: 'Search posts',
      link: true,
      href: '#',
    },
  },
};

const insightFeaturedV2: InsightsModel = {
  sectionHeading,
  view: InsightView.FEATURED_2,
  carouselDesktop: true,
  carousel: {
    ...insightCarousel,
    items: [
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[3],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[0],
      },
    ],
  },
};

const insightFeaturedV2WithGrid3: InsightsModel = {
  sectionHeading,
  view: InsightView.FEATURED_2_GRID_3,
  carouselDesktop: true,
  carousel: {
    ...insightCarousel,
    items: [
      {
        insight: insightItems[0],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[1],
      },
      {
        insight: insightItems[2],
      },
      {
        insight: insightItems[0],
      },
    ],
  },
};

export {
  insights4Items,
  featuredInsights,
  insights3Items,
  insights4ItemsWithSectionHeadingButton,
  insight2ColumnsSearchLoadMoreBase,
  featuredInsightsNoHeading,
  featuredViewFullImage,
  featuredViewMissingImage,
  featuredGridViewExtendViewNoneAll,
  featuredGridViewExtendViewCarousel,
  featuredGridViewExtendViewShowMore,
  gridViewExtendViewNoneAll,
  gridViewExtendViewCarousel,
  gridViewExtendViewShowMore,
  gridViewExtendViewMissingImage,
  gridViewExtendViewMissingImageNoDesc,
  gridView2ColumnsSearchPage,
  insight2ColumnsSearchBase,
  insightTheView,
  insightTheViewCarousel,
  insightFeaturedV2,
  insightFeaturedV2WithGrid3,
};
